<template>
  <svg width="16px" height="16px"
       viewBox="0 0 16 16" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>atoms/icons/16x16/chevron/down/black</title>
    <g id="atoms/icons/16x16/chevron/down/black" stroke="none"
       stroke-width="1"
       fill-rule="evenodd">
      <path d="M11.7168891,5.22265122 C12.1208046,4.84599392 12.7535838,4.86809106 13.1302411,5.27200656 C13.5068984,5.67592206 13.4848013,6.30870133 13.0808858,6.68535862 L8.69276359,10.7773488 C8.52029641,10.938177 8.30610302,11.0263048 8.08793863,11.0430505 C8.05361913,11.0454415 8.0272441,11.0462128 8.00088425,11.0459482 C7.97486707,11.0462141 7.94836355,11.045434 7.92191191,11.0436056 C7.6951808,11.0259111 7.48155825,10.9378182 7.30947591,10.7773488 L2.9213537,6.68535862 C2.51743821,6.30870133 2.49534107,5.67592206 2.87199836,5.27200656 C3.24865565,4.86809106 3.88143493,4.84599392 4.28535042,5.22265122 L8.00134825,8.68700111 Z" id="Combined-Shape"
      ></path>
    </g>
  </svg>
</template>
<script setup>
// dummy comment to surpress rollup build errors with dynamic imports
// if the file doesn't contain a script tag with content, the build fails.
</script>
